import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { DedicatedWorkflowPanel } from '../../../components/SystemShared/DedicatedWorkflowPanel';
import { messages } from '../../../containers/InviteAuthRep/PinRequired/PinRequired.i18n';
import PinRequired from '../../../containers/InviteAuthRep/PinRequired/PinRequired';
import { setIsDedicatedWorkflow } from '../../../redux/modules/workflow/workflow-action-creator';
import { inviteAuthRep } from '../../../redux/modules/ar-invitation/ar-invitation-middleware';
import LoadingIndicatorContainer from '../../../containers/LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../../redux/modules/loading-indicator/loading-indicator-middleware';
import { withAuth } from '../../../containers/Authenticated';


class PinRequiredPage extends React.Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(true));
    this.props.dispatch(callWithLoadingIndicator(
      'PinRequiredPage',
      () => this.props.dispatch(inviteAuthRep(this.props.contactId)))
    );
  }

  render = () => (
    <LoadingIndicatorContainer loadingKey="PinRequiredPage" >
      <DedicatedWorkflowPanel headerTitle={ messages.page.title } >
        <PinRequired pin={this.props.arInvitation ? this.props.arInvitation.pin : null} />
      </DedicatedWorkflowPanel>
    </LoadingIndicatorContainer>
  );
}

PinRequiredPage.propTypes = {
  dispatch: PropTypes.func,
  arInvitation: PropTypes.object,
  contactId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  contactId: state.personalContacts.selectedContactId,
  arInvitation: state.invitation.arInvitation,
});

const PinRequiredPageWithAuth = withAuth(PinRequiredPage);

export default withRouter(connect(mapStateToProps)(PinRequiredPageWithAuth));